/* SB builder behaviour: sliders (Splide, MIT), marquee timing, before/after drag, in-view video autoplay. */
(function () {
  const ready = fn => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  const num = (v, d) => (v === undefined || v === '' || isNaN(Number(v)) ? d : Number(v));
  const bool = v => v === 'true' || v === '1';

  function mountSlider(el) {
    if (el.__sMounted || !window.Splide) return;
    const d = el.dataset;
    const ppD = num(d.perPage, 1), ppM = num(d.perPageMobile, ppD);
    const opts = {
      perPage: ppD, perMove: 1, gap: num(d.gap, 15) + 'px', arrows: bool(d.arrows), pagination: bool(d.dots) || bool(d.dotsMobile),
      rewind: bool(d.rewind), autoplay: bool(d.autoplay), interval: num(d.speed, 4) * 1000, pauseOnHover: true, drag: true,
      speed: 400, trimSpace: true, padding: d.padding ? { right: d.padding } : 0, mediaQuery: 'max',
      breakpoints: { 750: { perPage: ppM, arrows: bool(d.arrowsMobile ?? d.arrows), pagination: bool(d.dotsMobile) } },
    };
    if (window.innerWidth > 750 && !bool(d.dots)) opts.pagination = false;
    try {
      const s = new window.Splide(el, opts);
      s.mount();
      el.__sMounted = true;
      el.classList.add('is-ready');
      // every slide fits in the view: no pagination, as on the old store (Splide can flag a 4-of-4 list as overflowing)
      const fit = () => el.classList.toggle('s-slider--fits', s.length <= Number(s.options.perPage || 1));
      fit();
      s.on('updated resized', fit);
    } catch (e) { console.warn('sb slider', e); }
  }

  function setupMarquee(el) {
    const track = el.querySelector('.s-mq__track');
    const group = el.querySelector('.s-mq__group');
    if (!track || !group) return;
    const speed = num(el.dataset.speed, 30);
    const w = group.getBoundingClientRect().width;
    // speed factor 30 ≈ 40px/s; larger factor = slower
    const pxPerSec = Math.max(10, 1200 / speed);
    track.style.setProperty('--dur', (w / pxPerSec).toFixed(2) + 's');
  }

  function setupBeforeAfter(el) {
    const set = x => {
      const r = el.getBoundingClientRect();
      const p = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
      el.style.setProperty('--pos', p + '%');
    };
    let drag = false;
    el.addEventListener('pointerdown', e => { drag = true; el.setPointerCapture(e.pointerId); set(e.clientX); });
    el.addEventListener('pointermove', e => { if (drag) set(e.clientX); });
    el.addEventListener('pointerup', () => { drag = false; });
    el.addEventListener('pointercancel', () => { drag = false; });
  }

  function setupVideos(root) {
    const vids = root.querySelectorAll('video[data-s-autoplay]');
    if (!vids.length) return;
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
    }), { threshold: 0.25 });
    vids.forEach(v => io.observe(v));
  }

  // click-to-play video block: the poster button swaps in the template's muted, looping video (with its controls)
  function setupClickVideos(root) {
    root.querySelectorAll('[data-s-video-play]').forEach(btn => {
      if (btn.__sVid) return;
      btn.__sVid = true;
      btn.addEventListener('click', () => {
        const wrap = btn.parentElement;
        const tpl = wrap && wrap.querySelector('template');
        const v = tpl && tpl.content.querySelector('video');
        if (!v || wrap.classList.contains('is-playing')) return;
        const vid = v.cloneNode(true);
        wrap.appendChild(vid);
        wrap.classList.add('is-playing');
        vid.muted = true;
        const p = vid.play();
        if (p && p.catch) p.catch(() => {});
        vid.focus({ preventScroll: true });
      });
    });
  }

  function init(root = document) {
    root.querySelectorAll('.s-slider[data-s-slider]').forEach(mountSlider);
    root.querySelectorAll('.s-mq').forEach(setupMarquee);
    root.querySelectorAll('.s-ba').forEach(setupBeforeAfter);
    setupVideos(root);
    setupClickVideos(root);
  }
  window.SbBuilder = { init };
  ready(() => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
